import React, { Fragment } from "react";
import {
  List,
  Datagrid,
  Filter,
  EditButton,
  Button,
  TextInput,
  TextField,
  FunctionField,
  ShowButton,
  useRecordContext,
  Link,
  Pagination,
  TopToolbar,
  ChipField,
  useListContext,
} from "react-admin";
import BulkActiveButton from './Action/Bulk.Active.Button';
import { stringify } from 'query-string';
import BulkRejectButton from './Action/Bulk.Reject.Button';
import DownloadIcon from '@material-ui/icons/GetApp';
import { WithdrawRequestStatusSelectInput, WithdrawRequestTypeSelectInput } from '../../UI/Input/SelectInput'

const PostPagination = () => <Pagination rowsPerPageOptions={[10, 25, 50, 100, 200, 300, 400, 500, 1000, 2000]} />;

const BulkActionButtons = ({ ...props }) => {

  return (<Fragment>
    <BulkActiveButton label="Bulck Active"  {...props} />
    <BulkRejectButton label="Bulck Reject"  {...props} />

  </Fragment>)
}
const ProfileidFiled = (props) => {
  const record = useRecordContext();
  return (
    <TextField {...props} component={Link} to={`/user?filter={"q":"${record.profile_id}"}`} onClick={(event) => event.stopPropagation()} />
  )
}



const ListFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="q" alwaysOn />
    <WithdrawRequestStatusSelectInput label="Status" source="req_status" alwaysOn />
    <WithdrawRequestTypeSelectInput label="Request Type" source="req_type" alwaysOn />
  </Filter>
);
////www.stage.tiruvannamalaiproperties.in/api/v1/1/customers/export?
// const ListActions = () => (
//   <TopToolbar>
//      <Button  href={'//sboportal.org.in/admin/api/v1/widthdraw/export?'} label="Export" ><DownloadIcon /></Button>
//   </TopToolbar>
// );

const ListActions = (props) => {
  const record = useListContext();
  const filva = record.filterValues ? stringify(record.filterValues) : '';
  return (<TopToolbar>
    <Button href={`//sboportal.org.in/admin/api/v1/widthdrawnew/export?${filva}`} label="Export Data" ><DownloadIcon /></Button>
  </TopToolbar>)
}

const WithdrawNewList = ({ ...props }) => {

  return (
    <Fragment>
      <List
        {...props}

        title="Withdraw Request"
        bulkActionButtons={<BulkActionButtons />}
        filters={<ListFilter />}
        sort={{ field: "name", order: "ASC" }}
        actions={<ListActions />}
        pagination={<PostPagination />}
      >
        <Datagrid >
          <TextField source="id" />
          <ProfileidFiled source="profile_id" label="Profile Id" />
         
          <TextField source="user.name" label="Name" />
          <TextField source="req_cvamount" label="CV amount" />
          <TextField source="total_amount" label="Transfer Amount" />
          <TextField source="req_type" label="Request Type" />
          <TextField source="created_at" label="Requested Date" />
          <FunctionField source="req_status" label="Status" render={record => {
            if (record['req_status'] === 'Decline') {
              return (<Button style={{ color: 'red', border: '1px solid' }} label="Decline" size="small"></Button>)
            } else if (record['req_status'] === 'Pending') {
              return (<Button style={{ color: 'orange', border: '1px solid' }} label="Pending" size="small"></Button>)
            } else if (record['req_status'] === 'Sent') {
              return (<Button style={{ color: 'green', border: '1px solid' }} label="Sent" size="small"></Button>)
            } else if (record['req_status'] === 'Cancelled') {
              return (<Button style={{ color: 'blue', border: '1px solid' }} label="Cancelled" size="small"></Button>)
            } else if (record['req_status'] === 'Processing') {
              return (<Button style={{ color: 'blue', border: '1px solid' }} label="Processing" size="small"></Button>)
            } else if (record['req_status'] === 'Transferd') {
              return (<Button style={{ color: 'blue', border: '1px solid' }} label="Transferd" size="small"></Button>)
            }
          }} />
         
          <ShowButton />
        </Datagrid>
      </List>

    </Fragment>
  );
};

export default WithdrawNewList;
